import { isCompozzError } from "@dto/CompozzError";
import { Tenant } from "@dto/Tenant";
import { useUserStore } from "src/store";
import { BASE_URL, USER_ORG_ID } from "./constants";
import { get } from "./utils";


export const fetchTenant = async () => {
    const orgId = useUserStore.getState().orgId || localStorage.getItem(USER_ORG_ID);
    const response = await get<Tenant>(`${BASE_URL}/admin/tenants/${orgId}`);
    if (isCompozzError(response)) {
        console.error(response);
        return null;
    }
    const tenant = response || null;
    return tenant;
}
